//  import React, { useState } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";

// const UnblockAccount = () => {
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const queryParams = new URLSearchParams(location.search);
//   const token = queryParams.get("token");
//   const email = queryParams.get("email");

//   const verifyOtp = async () => {
//     try {
//       setLoading(true);
//       setMessage("");
//       setError("");

//       const res = await axios.post(`${process.env.REACT_APP_SERVER_URL}/users/recover-unblock`, {
//         email,
//         token,
//       });

//       setMessage(res.data.message || "Account unblocked successfully!");
//       setTimeout(() => navigate("/login"), 1500);
//     } catch (err) {
//       console.log(err);
//       setError(err.response?.data?.message || "Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100">
//       <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
//         <h2 className="text-2xl font-bold mb-4">Unblock Your Account</h2>
//         {message && <p className="text-green-600">{message}</p>}
//         {error && <p className="text-red-500">{error}</p>}
//         {loading && <p className="text-gray-500">Verifying...</p>}

//         <button
//           onClick={verifyOtp}
//           className="mt-4 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
//         >
//           Unblock Account
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UnblockAccount;

import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const UnblockAccount = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  const verifyOtp = async () => {
    try {
      setLoading(true);
      setMessage("");
      setError("");

      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/users/recover-unblock`,
        { email, token }
      );

      setMessage(data.message || "Account unblocked successfully!");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-100 via-sky-100 to-teal-100 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        {/* Heading */}
        <h1 className="text-3xl font-extrabold text-gray-800 mb-6 text-center">
          Unblock&nbsp;Your&nbsp;Account
        </h1>

        {/* Success */}
        {!!message && (
          <div className="flex items-start gap-2 mb-4 rounded-lg bg-green-50 p-3 text-green-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-sm">{message}</span>
          </div>
        )}

        {/* Error */}
        {!!error && (
          <div className="flex items-start gap-2 mb-4 rounded-lg bg-red-50 p-3 text-red-700">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 flex-shrink-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span className="text-sm">{error}</span>
          </div>
        )}

        {/* Button */}
        <button
          onClick={verifyOtp}
          disabled={loading}
          className={`relative w-full py-3 rounded-lg text-white font-medium transition
            ${
              loading
                ? "bg-blue-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }
          `}
        >
          {loading && (
            <svg
              className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          )}
          {loading ? "Verifying…" : "Unblock Account"}
        </button>
      </div>
    </div>
  );
};

export default UnblockAccount;
